import {
  Component,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DobryAgentFacilityService } from '../../services/dobry-agent-facility.service';
import { PaymentMethodDobryAgent } from '../../interface/facility-dobry-agent';

@Component({
  selector: 'app-payment-method-dobry-agent-select',
  templateUrl: './payment-method-dobry-agent-select.component.html',
  styleUrls: ['./payment-method-dobry-agent-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PaymentMethodDobryAgentSelectComponent),
      multi: true,
    },
  ],
})
export class PaymentMethodDobryAgentSelectComponent implements OnInit, OnDestroy, ControlValueAccessor {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  @Input() label = 'Metody płatności';
  @Input() placeholder = 'Wybierz metody płatności';
  @Input() multiple = true;
  @Input() required = false;

  items: PaymentMethodDobryAgent[] = [];
  filteredItems: PaymentMethodDobryAgent[] = [];

  value: string | string[] | null = [];
  disabled = false;

  private onChange: (value: string | string[] | null) => void = () => {};
  private onTouched: () => void = () => {};

  constructor(
    private facilityDobryAgentService: DobryAgentFacilityService,
  ) {
  }

  ngOnInit(): void {
    this.facilityDobryAgentService.getPaymentMethodDobryAgentSubject()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((items: PaymentMethodDobryAgent[]) => {
        this.items = (items ?? [])
          .filter((item) => item.active)
          .filter((item) => !item.deleted);

        this.filteredItems = this.items;
      });
  }

  writeValue(value: string | string[] | null): void {
    this.value = value ?? (this.multiple ? [] : null);
  }

  registerOnChange(fn: (value: string | string[] | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  changeValue(value: string | string[] | null): void {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }

  compareByUuid(a: string | PaymentMethodDobryAgent, b: string | PaymentMethodDobryAgent): boolean {
    const first = typeof a === 'object' ? a?.uuid : a;
    const second = typeof b === 'object' ? b?.uuid : b;

    return first === second;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
